import { render, staticRenderFns } from "./BookDemo.vue?vue&type=template&id=1e160e52&scoped=true"
import script from "./BookDemo.vue?vue&type=script&lang=ts"
export * from "./BookDemo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e160e52",
  null
  
)

export default component.exports